"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewType = exports.NavigateFunction = exports.WebNavigateFunction = void 0;
const utils_1 = require("../../utils");
/**
 * @deprecated
 * export Navigate from AppWebview.PostMessage instead
 */
var WebNavigateFunction;
(function (WebNavigateFunction) {
    WebNavigateFunction["DISMISS_WEBVIEW"] = "dismissWebview";
    WebNavigateFunction["BACK_TO_HOME"] = "backToHome";
    WebNavigateFunction["OPEN_WEBVIEW"] = "openWebview";
})(WebNavigateFunction || (exports.WebNavigateFunction = WebNavigateFunction = {}));
/**
 * @deprecated
 * export Navigate from AppWebview.PostMessage instead
 */
(function (WebNavigateFunction) {
    WebNavigateFunction.fn = {
        values: utils_1.EnumUtils.valuesFunc(WebNavigateFunction),
        toEnumKey: utils_1.EnumUtils.toEnumKeyFunc(WebNavigateFunction),
        toEnumValue: utils_1.EnumUtils.toEnumValueFunc(WebNavigateFunction),
    };
})(WebNavigateFunction || (exports.WebNavigateFunction = WebNavigateFunction = {}));
var NavigateFunction;
(function (NavigateFunction) {
    NavigateFunction["RESET_TO"] = "resetTo";
    NavigateFunction["PUSH"] = "push";
    NavigateFunction["SHOW_MODAL"] = "showModal";
})(NavigateFunction || (exports.NavigateFunction = NavigateFunction = {}));
(function (NavigateFunction) {
    NavigateFunction.fn = {
        values: utils_1.EnumUtils.valuesFunc(NavigateFunction),
        toEnumKey: utils_1.EnumUtils.toEnumKeyFunc(NavigateFunction),
        toEnumValue: utils_1.EnumUtils.toEnumValueFunc(NavigateFunction),
    };
})(NavigateFunction || (exports.NavigateFunction = NavigateFunction = {}));
var ViewType;
(function (ViewType) {
    ViewType["MOBILE"] = "mobile";
    ViewType["WEB"] = "web";
})(ViewType || (exports.ViewType = ViewType = {}));
(function (ViewType) {
    ViewType.fn = {
        values: utils_1.EnumUtils.valuesFunc(ViewType),
        toEnumKey: utils_1.EnumUtils.toEnumKeyFunc(ViewType),
        toEnumValue: utils_1.EnumUtils.toEnumValueFunc(ViewType),
    };
})(ViewType || (exports.ViewType = ViewType = {}));
//# sourceMappingURL=enums.js.map